<header>
	<div class="logo-version-wrapper">
		<img
			src="assets/img/asfinag_logo.svg"
			alt="ASFINAG Logo"
		/>
		<div class="version">v{{ version }}</div>

		<dr-digital-equipment-form
			*ngIf="!showListBtn && isUserLoggedIn"
			[allDigitalEquipments]="allDigitalEquipments"
			[canEditDigitalEquipment]="true"
			[assetIdToShow]="currentAssetIdNumber ?? undefined"
			(digitalEquipmentChanged)="handleDigitalEquipmentChanged($event)"
		>
		</dr-digital-equipment-form>
	</div>
	<div
		*ngIf="!isUserLoggedIn"
		class="cef-logo"
	>
		<img
			src="assets/img/CefLogo.png"
			alt="CEFlogo"
		/>
	</div>
	<nav *ngIf="isUserLoggedIn">
		<a
			*ngIf="showListBtn"
			mat-icon-button
			color="accent"
			[routerLink]="'/' + availableRoutePaths.List"
		>
			<mat-icon
				[ngClass]="{ roadworkView: showListBtn }"
				[svgIcon]="'list'"
			></mat-icon>
		</a>
		<button
			mat-icon-button
			color="accent"
			[matMenuTriggerFor]="userMenu"
		>
			<mat-icon
				[ngClass]="{ roadworkView: showListBtn }"
				[svgIcon]="'person'"
			></mat-icon>
		</button>
	</nav>
</header>
<mat-menu
	#notificationsMenu="matMenu"
	class="dr-notification-menu"
>
</mat-menu>
<mat-menu
	#userMenu="matMenu"
	class="dr-user-menu"
>
	<ng-container *ngIf="user">
		<div class="username">{{ user.fullName }}</div>
		<mat-chip-listbox *ngIf="user.purviewNames.length; else noPurviewAssigned">
			<mat-chip *ngFor="let purview of user.purviewNames">{{ purview }}</mat-chip>
		</mat-chip-listbox>

		<ng-template #noPurviewAssigned>
			<div class="no-purview-assigned">
				{{ "header.no-purview-assigned" | translate }}
			</div>
		</ng-template>
		<button
			class="logout-button"
			mat-raised-button
			(click)="logout()"
		>
			{{ "header.logout-btn-text" | translate }}
		</button>
	</ng-container>
</mat-menu>
